const Fetcher = require('od-modules/utils/fetcher');
const MARKER_OPTIONS = {
    anchorOffset: 5,
    arrowOffset: 10,
    markerWidth: 25, // .od-custom-marker-pin width
};

function getHotelDetailsMapMarkerServiceUrl(markerKey) {
    const service = Odigeo.Settings.getProperty('serviceUrlFormatter');
    const endpoint = `accommodation/google-dynamic-map/${Odigeo.History.getPageNameFromFragment()}/marker/${markerKey}`;
    return service(endpoint);
}
module.exports = function(libMap) {
    function Marker(options) {
        this.libMap = libMap;
        this.map = options.map;
        this.position = options.position;
        this.dataMarker = options.dataMarker;
        this.onClickMarker = options.onClickMarker;
        this.preselectedIcon = options.preselectedIcon;
        this.hasTopVisibilityMarkerPreselected = options.hasTopVisibilityMarkerPreselected;
        this.mapConfig = options.mapConfig;
    }

    // @Override google.maps.OverlayView
    Marker.prototype.draw = function() {
        this.setPoint(this.getProjection().fromLatLngToDivPixel(this.position));
        this.el.style.left = this.getDivPoint().x + 'px';
        this.el.style.top = this.getDivPoint().y + 'px';
    };

    // @Override google.maps.OverlayView
    Marker.prototype.onAdd = function() {
        this.el = document.createElement('div');
        this.render();
        this.prepareElement();
        this.bindEvents();
    };

    // @Override google.maps.OverlayView
    Marker.prototype.onRemove = function() {
        $(this.el).remove();
    };

    Marker.prototype.getStatus = function() {
        return {
            isSelected: this.dataMarker.hasSelectedHotelInfoIndex,
            isPreselected: this.hasTopVisibilityMarkerPreselected && this.dataMarker.preselected,
            isTopChoice: this.dataMarker.isTopChoice,
        };
    };

    Marker.prototype.bindEvents = function() {
        this.libMap.event.clearListeners(this, 'changeIcon');
        this.libMap.event.addListener(this, 'changeIcon', Odigeo._.bind(this.setInfoWindowsOptions, this));
        this.libMap.event.addListener(this, 'changeIcon', Odigeo._.bind(this.render, this));
        this.libMap.event.addDomListener(this.el, 'click', Odigeo._.partial(this.onClickMarker, _, this));
        this.libMap.event.addDomListener(this.el, 'dblclick', function(ev) {
            ev.stopPropagation();
        });
    };

    Marker.prototype.setOptions = function(options) {
        this.options = Odigeo._.extend({}, MARKER_OPTIONS, options);
    };

    Marker.prototype.setInfoWindowsOptions = function(options) {
        this.options.infoWindowOptions = Odigeo._.get(options, 'infoWindowOptions', {});
    };

    Marker.prototype.getPosition = function() {
        return this.position;
    };

    Marker.prototype.setPoint = function(point) {
        this.point = point;
    };

    Marker.prototype.getPoint = function() {
        return Odigeo._.clone(this.point) || new this.libMap.Point(0, 0);
    };

    Marker.prototype.getDiv = function() {
        return this.el || {};
    };

    Marker.prototype.getAnchorPoint = function() {
        const size = this.getElementSize();
        return new this.libMap.Point(0, -(size.height + this.options.anchorOffset));
    };

    Marker.prototype.getDivPoint = function() {
        const point = this.getPoint();
        const size = this.getElementSize();

        point.x -= size.width / 2;
        point.y -= size.height;

        return point;
    };

    Marker.prototype.getElementSize = function() {
        return {
            width: this.el.offsetWidth,
            height: this.el.offsetHeight + this.options.arrowOffset,
        };
    };

    Marker.prototype.setClass = function(className) {
        this.el.className = this.options.cssClass.base + ' ' + className;
    };

    Marker.prototype.prepareElement = function() {
        this.libMap.event.addDomListener(this.el, 'click', Odigeo._.bind(function() {
            this.libMap.event.trigger(this, 'click');
        }, this));
        this.getPanes().overlayMouseTarget.appendChild(this.el);
    };

    Marker.prototype.setOffset = function(hasToResetPosition) {
        const position = hasToResetPosition ? ($(this.el).outerWidth() - this.options.markerWidth) / 2 : 0;

        this.el.style.marginLeft = position + 'px';
    };

    Marker.prototype.hasElement = function() {
        return Odigeo._.isElement(this.getDiv());
    };

    Marker.prototype.setDataMarker = function(key, value) {
        this.dataMarker[key] = value;
    };

    Marker.prototype.setGalleryImage = function(elHtml, options) {
        this.dataMarker.galleryImage = Odigeo.UIElements.enhanceCarousel(elHtml, options || {});
    };

    Marker.prototype.setSelectedStatus = function(hasSelected) {
        this.dataMarker.hasSelectedHotelInfoIndex = hasSelected;
    };

    Marker.prototype.fetchHotelDetails = function() {
        return !Odigeo._.isEmpty(this.dataMarker.accommodationDeal)
            ? Promise.resolve(this.dataMarker)
            : Fetcher.get(getHotelDetailsMapMarkerServiceUrl(this.dataMarker.accommodationDealKey)).json()
                .then((hotelDetails) => Object.assign(this.dataMarker, hotelDetails));
    };

    return Marker;
};
